import React from "react";

export default function IconButton({
  onClick,
  disabled = false,
  children, slim, style, ...props 
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 40,
        height: 40,
        border: "none",
        borderRadius: "50%",
        background: "transparent",
        cursor: disabled ? "default" : "pointer",
        padding: 0,
        ...style,
      }}
    >
      {children}
    </button>
  );
}